import React from 'react';
import { Link } from 'react-router-dom';
export function TopBanner() {
  return <div className="bg-clean-grey text-slate-500 py-2 px-4 sm:px-6 lg:px-8 border-b border-slate-200 text-[9px] md:text-[10px] uppercase tracking-widest font-bold" data-id="element-301">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-center sm:justify-end items-center gap-2 sm:gap-6 text-center sm:text-left" data-id="element-302">
        <a href="https://www.google.com/maps/dir/?api=1&destination=2002+Jennifer+Rd+Annapolis+MD+21401" target="_blank" rel="noopener noreferrer" className="hover:text-clinical-blue transition-colors" data-id="element-303">
          Annapolis Pharmacy
        </a>
        <span className="hidden sm:block h-3 w-px bg-slate-300" data-id="element-304"></span>
        <a href="https://www.google.com/maps/dir/?api=1&destination=1234+Pennsylvania+Ave+NW+Washington+DC+20004" target="_blank" rel="noopener noreferrer" className="hover:text-clinical-blue transition-colors" data-id="element-305">
          Washington D.C. Pharmacy
        </a>
      </div>
    </div>;
}